/** Shared polling interval for auto-refresh toggles in manage views. */
export const AUTOREFRESH_INTERVAL = 10_000;
